import { render, staticRenderFns } from "./FollowUpPatientStep14Component.vue?vue&type=template&id=36dc20b2&scoped=true&"
import script from "./FollowUpPatientStep14Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep14Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc20b2",
  null
  
)

export default component.exports